import { Button, Divider, Flex, Typography } from "antd";
import { useAppDispatch } from "../../util/hooks";
import * as Icon from "@ant-design/icons";

const { Text } = Typography;

type MensagemProps = {
  text: string;
  action: any;
  close: any;
};

const MensagemModal = ({ text, action, close }: MensagemProps) => {
  //hooks
  const dispatch = useAppDispatch();

  const deletar = () => {
    dispatch(action);
  };

  const voltar = () => {
    dispatch(close);
  };

  return (
    <Flex vertical>
      <Text style={{ fontSize: 16 }}>{text}</Text>
      <Divider />
      <Flex justify="flex-end" align="center" gap={10}>
        <Button className="buttonPrimary" onClick={deletar} icon={<Icon.CheckOutlined />}>
          SIM
        </Button>
        <Button className="cancelButton" onClick={voltar} icon={<Icon.CloseOutlined />}>
          NÃO
        </Button>
      </Flex>
    </Flex>
  );
};

export default MensagemModal;
